<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Education Backgrounds"
      text="Update education backgrounds"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localEducationBackground.education_level_id"
                v-validate="'required'"
                :items="educationLevels"
                label="Education Level"
                :error-messages="errors.collect('education_level_id')"
                data-vv-name="education_level_id"    
                data-vv-as="education level"     
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!localEducationBackground.education_level_id
                }"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localEducationBackground.education_major_id"
                v-validate="'required'"
                :items="educationMajors"
                label="Education Major"
                :error-messages="errors.collect('education_major_id')"
                data-vv-name="education_major_id"    
                data-vv-as="education major"     
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!localEducationBackground.education_major_id
                }"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete 
                v-model="localEducationBackground.country_id"
                v-validate="'required'"
                :items="countries"
                label="Country"
                :error-messages="errors.collect('country')"
                data-vv-name="country"  
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!localEducationBackground.country_id
                }"
                @change="localEducationBackground.education_institution_id = null"
              />
            </v-col>
           
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-autocomplete
                v-model="localEducationBackground.education_institution_id"
                v-validate="'required'"
                :items="filterededucationInstitutes"
                label="Education Institute"
                :error-messages="errors.collect('education_institution_id')"
                data-vv-name="education_institution_id"    
                data-vv-as="education institute"     
                item-text="name"
                item-value="id"
                outlined
                :class="{
                  'required':!localEducationBackground.education_institution_id
                }"
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localEducationBackground.result"
                label="Result" 
                outlined
              />
            </v-col>

            <v-col
              cols="12"
              class="pb-0"
            >
              <v-text-field
                v-model="localEducationBackground.graduation_year"
                v-mask="mask"
                v-validate="'required'"
                label="Graduation Year"
                :error-messages="errors.collect('graduation_year')"
                data-vv-name="graduation_year"    
                data-vv-as="graduation year"
                outlined
                :class="{
                  'required':!localEducationBackground.graduation_year
                }"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card> 
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      educationBackground: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        mask: '####',
        dialog: false,
        progressing: false,
        localEducationBackground: null,
        loading: false,
        educationLevels: [],
        educationMajors: [],
        educationInstitutes: [],
        countries: [],
      }
    },

    computed: {
      filterededucationInstitutes () {
        if (!this.localEducationBackground.country_id) return this.educationInstitutes
        
        return this.educationInstitutes.filter(educationInstitution => {
          return educationInstitution.country_id === this.localEducationBackground.country_id
        })
      },
    },

    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localEducationBackground = { ...this.educationBackground }

        Promise.all([
          this.$api.hrisEducationLevels().list(),
          this.$api.hrisEducationMajors().list(),
          this.$api.hrisEducationInstitutes().list(),
          this.$api.hrisCountries().list(),
        ])
          .then(([educationLevels, educationMajors, educationInstitutes, countries]) => {
            this.educationLevels = educationLevels.data
            this.educationMajors = educationMajors.data
            this.educationInstitutes = educationInstitutes.data
            this.countries = countries.data

            this.loading = false
          })
      },
    },
    methods: { 
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisEducationBackgrounds().update(this.educationBackground.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          education_level_id: this.localEducationBackground.education_level_id,
          education_major_id: this.localEducationBackground.education_major_id,
          country_id: this.localEducationBackground.country_id,
          education_institution_id: this.localEducationBackground.education_institution_id,
          result: this.localEducationBackground.result,
          graduation_year: this.localEducationBackground.graduation_year,
        }
      },
    },
  }
</script>

<style scoped>
.required >>> fieldset {
  border: 2px solid red;
}
</style>
